module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-3 footer-lg"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('FooterLogo')], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-5 footer-menu"
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Главная")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Преимущества")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Возможности")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Галерея")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Подписаться")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Поддержать")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Котакты")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 col-md-4 footer-social"
  }, [_c('div', {
    staticClass: "footer-social-title"
  }, [_vm._v("\n                        Мы в соцсетях\n                    ")]), _vm._v(" "), _c('section', {
    staticClass: "social-icons"
  }, [_c('h3', {
    staticClass: "hide"
  }, [_vm._v("Social Buttons")]), _vm._v(" "), _c('a', {
    staticClass: "btn-social facebook",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Facebook",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social twitter",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Twitter",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social google-plus",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Google+",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-google-plus"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social youtube",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Youtube",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-youtube"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social instagram",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Instagram",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-instagram"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social email",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "Email",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-envelope"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn-social rss",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": "RSS",
      "href": "#",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "fa fa-rss"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bottom"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "col-xs-12 footer-copyright"
  }, [_vm._v("© 2018 — Hottt. All rights reserved.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc0da8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Footer.vue
// module id = 1229
// module chunks = 1